/**
 * useHardReloadIfPolling — navigation guard for in-flight background polling.
 *
 * While useSessionUpdates is polling on the session detail page, a client-side
 * navigation can be undone by the poll resolving and repopulating
 * currentSession (which bounces the user back to the detail page). A hard page
 * load tears down all in-flight requests and Redux state, so nothing stale can
 * repopulate.
 *
 * Returns a function that hard-loads `path` and returns true when polling is in
 * flight; otherwise it does nothing and returns false, leaving the caller to
 * perform its normal client-side navigation.
 */

import { useAppStore } from '../store/store';

export const useHardReloadIfPolling = () => {
  const store = useAppStore();
  return (path: string): boolean => {
    if (store.getState().session.isPolling) {
      window.location.assign(path);
      return true;
    }
    return false;
  };
};
